import mimes from 'mime-types';
import { mimeTypeMap } from '../src/constants/mimeTypeMap.js';

export default {
    addFileToFolderRec(id, items, fileToAdd) {
        let foundFolder = items.find(item => item.id == id && item.type.toUpperCase() === 'REGISTER');
        if (!foundFolder) {
            items.forEach(i => {
                if (i.children && i.children.length > 0) {
                    this.addFileToFolderRec(id, i.children, fileToAdd);
                }
            });
        } else {
            console.log('FOUND FOLDER', foundFolder);
            if (!foundFolder.children) foundFolder.children = [];
            foundFolder.children.push(fileToAdd);
            return;
        }
    },

    removeFileFromFolderRec(id, items, fileIdToRemove) {
        let foundFolder = items.find(item => item.id == id && item.type.toUpperCase() === 'REGISTER');
        if (!foundFolder) {
            items.forEach(i => {
                if (i.children && i.children.length > 0) {
                    this.removeFileFromFolderRec(id, i.children, fileIdToRemove);
                }
            });
        } else {
            console.log('FOUND FOLDER', foundFolder);
            let fileIndex = foundFolder.children.findIndex(item => item.id === fileIdToRemove);
            foundFolder.children.splice(fileIndex, 1);
            return;
        }
    },

    initChildren(rootNode) {
        if (!rootNode.children) {
            rootNode.children = [];
        }

        if (rootNode.children.length > 0) {
            rootNode.children.forEach(childNode => {
                this.initChildren(childNode);
            });
        }
    },

    collectFilesDataRec(selectedFiles, filesArray) {
        filesArray = filesArray || [];

        selectedFiles.forEach(file => {
            let fileData = {
                title: file.title,
                id: file.id
            }

            if(file.type.toUpperCase() === ('REGISTER' || 'FOLDER') && file.children.length > 0) {
                fileData.children = this.collectFilesDataRec(file.children, fileData.children);
            } else {
                fileData.extension = this.getFileTypeExtension(file).toLowerCase()
            }

            filesArray.push(fileData);
        });

        return filesArray;
    },

    getFileTypeExtension(file) {
        if (!file.mimeType) return '';

        let extension = mimes.extension(file.mimeType);
        extension = extension ? (extension || '') : mimeTypeMap[file.mimeType];

        return extension.toUpperCase();
    },

    checkDuplicateProperty(propertyName, inputArray) {
        let helperObj = {}, finalArr = [];

        inputArray.map(item => {
            let itemPropertyName = item[propertyName].toLowerCase();

            if(itemPropertyName in helperObj) {
                helperObj[itemPropertyName].duplicate = true;
                item.duplicate = true;
            } else {
                helperObj[itemPropertyName] = item;
                delete item.duplicate;
            }

            finalArr.push(item);
        })
        
        return finalArr;
    }
};
